import React from "react";
import { Box } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { colors } from "../../config";

export type AlertVariant = "danger" | "warning";
export type AlertType =
  | "amazonShareBuyBox"
  | "privateLabel"
  | "ipAnalysis"
  | "fulfillmentFee"
  | "variations"
  | "hazmat"
  | "meltable"
  | "size"
  | "info"
  | "success"
  | "error";

interface AlertProps {
  variant: AlertVariant;
  type: AlertType;
}

const iconMap: Record<
  AlertType,
  React.ComponentType<{ sx?: any }>
> = {
  amazonShareBuyBox: ErrorOutlineIcon,
  privateLabel: ErrorOutlineIcon,
  ipAnalysis: WarningIcon,
  fulfillmentFee: WarningIcon,
  variations: ErrorOutlineIcon,
  hazmat: WarningIcon,
  meltable: WarningIcon,
  size: InfoIcon,
  info: InfoIcon,
  success: CheckCircleIcon,
  error: CancelIcon,
};

const Alert: React.FC<AlertProps> = ({ variant, type }) => {
  const IconComponent = iconMap[type];

  const styles = {
    danger: {
      backgroundColor: colors.error.alertBackground, // Light red background
      iconColor: colors.error.icon, // Darker red for icon
    },
    warning: {
      backgroundColor: colors.warning.background, // Yellow background
      iconColor: colors.warning.icon, // Darker yellow/brown for icon
    },
  };

  const currentStyle = styles[variant];

  return (
    <Box
      sx={{
        width: "25px",
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        backgroundColor: currentStyle.backgroundColor,
      }}
    >
      <IconComponent
        sx={{
          fontSize: "16px",
          color: currentStyle.iconColor,
        }}
      />
    </Box>
  );
};

export default Alert;
